<div class="detail-container">
  <div class="detail-container__header" *ngIf="hasTitle()">
    <h1 class="detail-container__title">{{ title }}</h1>
  </div>

  <div class="detail-container__content">
    <ng-content></ng-content>
  </div>
</div>
